<template>
  <b-container class="fullContent shadow" fluid>
    <b-row>
      <b-col class="px-1 px-md-3 px-lg-6 py-3 shadow bg-white" offset-xl="2" xl="8">
        <b-row class="justify-content-between px-3 mb-3">
          <h2 class="col-12 col-md-9 col-xl-7">Welcome to FOResT!</h2>
          <b-button
            v-if="!mfsUser && !tceoUser && !infwbUser"
            class="col col-sm-auto d-lg-inline-block mx-3 my-3 my-sm-auto"
            to="notification/new"
            router-tag="button"
            variant="secondary"
            pill
            aria-label="Create new notification"
          >
            Create Notification
          </b-button>
        </b-row>
        <template v-if="mfsUser">
          <b-row class="px-3">
            <GoToNotification class="col-12 col-sm-6" />
          </b-row>
          <div class="px-3 w-100 py-3 py-lg-auto">
            <hr class="border-dark">
          </div>
          <Search />
        </template>
        <template v-else-if="tceoUser || infwbUser">
          <MyActiveTownNotifications />
        </template>
        <template v-else>
          <div class="px-3 w-100 d-block d-sm-none">
            <hr class="border-dark">
          </div>
          <NewsModal />
          <MyNotifications />
          <MyLandownerReports />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import GoToNotification from '@/components/dashboard/GoToNotification.vue';
import MyNotifications from '@/components/dashboard/MyNotifications.vue';
import MyLandownerReports from '@/components/dashboard/MyLandownerReports.vue';
import MyActiveTownNotifications from '@/components/dashboard/MyActiveTownNotifications.vue';
import Search from '@/components/dashboard/Search.vue';
import NewsModal from '@/components/dashboard/NewsModal.vue';

export default {
  name: 'Dashboard',
  components: {
    GoToNotification,
    MyNotifications,
    MyLandownerReports,
    MyActiveTownNotifications,
    Search,
    NewsModal,
  },
  mounted() {
    this.init(); // init will execute at pageload
  },
  computed: {
    ...mapGetters('User', ['mfsUser', 'tceoUser', 'infwbUser', 'needNotification']),
  },
  methods: {
    init() {
      if (this.needNotification) {
        this.$bvModal.show('NewsModal');
      }
    },
  },
};
</script>
